const shopService = {
    getAll() {
        return axios.get('/api/v1/shop/').then(
            (response) => {
                return response.data.data;
            }
        );
    },
    getByID(id) {
        return axios.get('/api/v1/shop/'+id).then(
            (response) => {
                return response.data.data;
            }
        );
    },
    update(id,data) {
        return axios.put('/api/v1/shop/'+id , data )
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
    create(data) {
        return axios.post('/api/v1/shop/', data )
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
};

export default shopService;
